<template>
    <div class="print-btn-group">
  
      <!-- Download PDF -->
      <button
        class="print-btn"
        @click="createPDF(title, isAdjustmentOrTransfer)"
        :disabled="loading"
        title="Download as PDF"
      >
        <font-awesome-icon icon="download" class="me-2" />
        PDF
      </button>
  
      <!-- 80mm -->
      <button
        class="print-btn"
        :class="is80mm ? 'print-btn--active' : ''"
        @click="is80mm ? printPage('80mm') : get80mm()"
        :disabled="loading"
        :title="is80mm ? 'Print 80mm' : 'View 80mm'"
      >
        <font-awesome-icon :icon="is80mm ? 'print' : 'file-alt'" class="me-2" />
        {{ is80mm ? 'Print 80mm' : '80mm' }}
      </button>

      <!-- A4 -->
      <button
        class="print-btn"
        :class="isA4 ? 'print-btn--active' : ''"
        @click="isA4 ? createPDF(title, isAdjustmentOrTransfer) : getA4()"
        :disabled="loading"
        :title="isA4 ? 'Download A4 PDF' : 'View A4'"
      >
        <font-awesome-icon :icon="isA4 ? 'file-pdf' : 'file-invoice'" class="me-2" />
        {{ isA4 ? 'Download A4' : 'A4' }}
      </button>
  
    </div>
  </template>
  
  <script>
  import { reusableMixin } from '../lib/reusableMixin';
  
  export default {
    mixins: [reusableMixin],
  
    props: {
      title:      { type: String,  default: '' },
      urlA4:      { type: String,  default: '' },
      url58mm:    { type: String,  default: '' },
      url80mm:    { type: String,  default: '' },
      currentUrl: { type: String,  default: '' },
      type:       { type: String,  default: '' },
      data:       { type: Object,  default: () => ({}) },
      loading:    { type: Boolean, default: false },
    },
  
    computed: {
      currentName() {
        return this.$router.currentRoute.value.name;
      },
      is80mm() {
        return this.currentName === `Print 80mm ${this.type}`;
      },
      isA4() {
        return this.currentName === `View ${this.type}`;
      },
      isAdjustmentOrTransfer() {
        return (
          this.currentName === 'View Stock Adjustment' ||
          this.currentName === 'View Stock Transfer'
        );
      },
    },
  
    methods: {
      // Override mixin's popup-based printPage with the visibility trick so
      // scoped component styles are preserved during printing.
      printPage(width) {
        const isNarrow = /^\d+mm$/.test(width) && parseInt(width) <= 80;
        const margin   = isNarrow ? '4mm' : '12mm';

        const style = document.createElement('style');
        style.id    = '__print-receipt-override';
        style.innerHTML = `
          @page { size: ${width} auto; margin: ${margin}; }
          @media print {
            body > * { visibility: hidden !important; }
            #printMe, #printMe * { visibility: visible !important; }
            #printMe {
              position: absolute;
              left: 0; top: 0;
              width: 100%;
              background: white;
              padding: ${isNarrow ? '6px' : '20px'};
              box-sizing: border-box;
            }
            ${isNarrow ? '.col-barcode, .col-uom { display: none !important; }' : ''}
          }
        `;
        document.head.appendChild(style);
        window.print();
        setTimeout(() => document.getElementById('__print-receipt-override')?.remove(), 1000);
      },

      get80mm() {
        if (!this.is80mm) this.$router.push(this.url80mm + this.data?.id);
      },
      getA4() {
        if (!this.isA4) this.$router.push(this.urlA4 + this.data?.id);
      },
    },
  };
  </script>
  
  <style scoped>
  .print-btn-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  
  .print-btn {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
    background: #fff;
    color: #1a2b45;
    border: 1px solid #dde5f0;
    font-size: 13px;
    font-weight: 500;
    padding: 8px 16px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
  }
  
  .print-btn:hover:not(:disabled) {
    background: #f4f7fb;
    border-color: #c5d0dc;
  }
  
  .print-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  
  /* Active state — currently on this print page */
  .print-btn--active {
    background: #004AAD;
    color: #fff;
    border-color: #004AAD;
  }
  
  .print-btn--active:hover:not(:disabled) {
    background: #003b8e;
    border-color: #003b8e;
  }
  
  @media (max-width: 576px) {
    .print-btn-group { flex-direction: column; width: 100%; }
    .print-btn       { width: 100%; justify-content: center; }
  }
  </style>